import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "voxivr_token";

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

// Attach token on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 by clearing token and bouncing to /login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      // Avoid bouncing while we're already on the login screen
      if (!window.location.pathname.startsWith("/login")) {
        window.location.assign("/login");
      }
    }
    return Promise.reject(err);
  }
);

export function extractError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  // FastAPI 422 returns an array of `{ loc, msg, type, ... }` objects.
  if (Array.isArray(detail)) {
    return detail
      .slice(0, 3)
      .map((e) => {
        const path = (e.loc || []).filter((x) => x !== "body").join(".");
        return path ? `${path}: ${e.msg}` : e.msg;
      })
      .join("; ");
  }
  if (typeof detail === "string") return detail;
  return (
    err?.response?.data?.message ||
    err?.message ||
    fallback
  );
}

export function toastError(err, fallback) {
  toast.error(extractError(err, fallback));
}
